import * as yup from 'yup';

export const webGameFormValidationSchema = (
  thumbnailFileId: number | null,
  zipFileId: number | null
) =>
  yup.object().shape({
    title: yup.string().required('Please add a game title !'),
    thumbnail: yup
      .number()
      .nullable()
      .test(
        'ICON file test',
        'Please add one thumbnail !',
        () => thumbnailFileId !== null
      )
      .required(),
    zip: yup
      .number()
      .nullable()
      .test(
        'DOCUMENT  file test',
        'Please add one zip !',
        () => zipFileId !== null
      )
      .required(),
    genre: yup.string(),
    size: yup.string(),
    orientation: yup.string(),
  });
